import ResourceStatus from './ResourceStatus';
import React from 'react';
import PropTypes from 'prop-types';
import TabbedSubmenu from '../core/TabbedSubmenu';

class LifeCycle extends React.Component {

    render() {

        const { id, graph, defaultLang, projectIRI, components, onToggleView, sortProp, inProp, labelType, rto,
            useWorkflow, projectType, rtoDeprecated, largeDataSettings } = this.props;

        const tabs = useWorkflow ?
            largeDataSettings ?
                ["Deprecated", "Draft", "Rejected"]
                :
                ["Deprecated", "Uncategorised", "Draft", "Rejected"]
            :
            ["Deprecated"];

        let items = [<ResourceStatus
            id={id}
            key="Deprecated"
            graph={graph}
            defaultLang={defaultLang}
            projectType={projectType}
            entailment={true}
            onToggleView={onToggleView}
            predicate="http://www.w3.org/2002/07/owl#deprecated"
            components={components}
            within={inProp}
            sortProp={sortProp}
            labelType={labelType}
            // Might need different for deprecated but if not use normal
            resourceTypeOptions={rtoDeprecated || rto}
            projectIRI={projectIRI}
            componentIRI={id} />
        ];

        if (useWorkflow) {
            if (!largeDataSettings) {
                items.push(<ResourceStatus
                    id={id}
                    key="Uncategorised"
                    graph={graph}
                    entailment={true}
                    projectType={projectType}
                    defaultLang={defaultLang}
                    onToggleView={onToggleView}
                    predicate="https://grafsync.graphifi.com/schema/gs/status"
                    predicateInverted={true}
                    components={components}
                    sortProp={sortProp}
                    within={inProp}
                    labelType={labelType}
                    resourceTypeOptions={rto}
                    projectIRI={projectIRI}
                    componentIRI={id} />
                )
            }
            items.push(<ResourceStatus
                id={id}
                key="Draft"
                graph={graph}
                entailment={true}
                projectType={projectType}
                defaultLang={defaultLang}
                onToggleView={onToggleView}
                predicate="https://grafsync.graphifi.com/schema/gs/status"
                predicateValue="https://grafsync.graphifi.com/schema/gs/draft"
                components={components}
                sortProp={sortProp}
                within={inProp}
                labelType={labelType}
                resourceTypeOptions={rto}
                projectIRI={projectIRI}
                componentIRI={id} />
            );
            items.push(<ResourceStatus
                id={id}
                key="Rejected"
                graph={graph}
                entailment={true}
                projectType={projectType}
                defaultLang={defaultLang}
                onToggleView={onToggleView}
                predicate="https://grafsync.graphifi.com/schema/gs/status"
                predicateValue="https://grafsync.graphifi.com/schema/gs/rejected"
                components={components}
                sortProp={sortProp}
                within={inProp}
                labelType={labelType}
                resourceTypeOptions={rto}
                projectIRI={projectIRI}
                componentIRI={id} />);
        }

        return (
            <TabbedSubmenu tabs={tabs}>
                {items}
            </TabbedSubmenu>
        );
    }
}

LifeCycle.defaultProps = {
    components: [],
    largeDataSettings: false
};

LifeCycle.propTypes = {
    projectType: PropTypes.string.isRequired,
    entitlements: PropTypes.array.isRequired,
    examples: PropTypes.array,
    rto: PropTypes.array.isRequired,
    rtoDeprecated: PropTypes.array,
    sortProp: PropTypes.string.isRequired,
    inProp: PropTypes.array.isRequired,
    labelType: PropTypes.array.isRequired,
    components: PropTypes.array.isRequired,
    id: PropTypes.string.isRequired,
    onToggleView: PropTypes.func,
    largeDataSettings: PropTypes.bool,
    graph: PropTypes.string.isRequired,
    projectIRI: PropTypes.string.isRequired,
    skosXL: PropTypes.bool.isRequired,
    defaultLang: PropTypes.string.isRequired,
    ontologyProjectAssociation: PropTypes.array
};

export default LifeCycle;